import { render, staticRenderFns } from "./UserActionsModal.vue?vue&type=template&id=70d68666&scoped=true&"
import script from "./UserActionsModal.vue?vue&type=script&lang=js&"
export * from "./UserActionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d68666",
  null
  
)

export default component.exports